import { useModal } from '@/utils'
import { ReactNode, useRef, JSX } from 'react'
import { createPortal } from 'react-dom'
import { Typography } from '../../atoms'
import { Row } from '../../styled'
import { useFloatPositioning } from '../Tooltip/helpers'
import { Container, Content, StyledClose } from './styles'

export interface PopoverProps {
  content: ReactNode
  children: ReactNode
  dark?: boolean
}

export const Popover = ({
  content,
  children,
  dark,
}: PopoverProps): JSX.Element => {
  const popoverRef = useRef<HTMLDivElement>(null)
  const elementRef = useRef<HTMLDivElement>(null)

  const { isOpen, toggle } = useModal()

  useFloatPositioning({
    isOpen,
    ref: popoverRef,
    relatedToRef: elementRef,
    noRepositionTop: true,
  })

  return (
    <Container dark={dark} isOpen={isOpen}>
      {isOpen &&
        createPortal(
          <Content ref={popoverRef} dark={dark}>
            <Row justifyContent="end">
              <StyledClose onClick={toggle} size="tag" />
            </Row>
            {content}
          </Content>,
          document.body,
        )}
      <Typography ref={elementRef} onClick={toggle} variant="p2Body">
        {children}
      </Typography>
    </Container>
  )
}
